import { render, staticRenderFns } from "./PageViewOrderDetail.vue?vue&type=template&id=2b475a20&scoped=true&"
import script from "./PageViewOrderDetail.vue?vue&type=script&lang=ts&"
export * from "./PageViewOrderDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PageViewOrderDetail.vue?vue&type=style&index=0&id=2b475a20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b475a20",
  null
  
)

export default component.exports